<template>
  <div>
    <h4 class="mb-0">Indiquez votre identifiant Cyber Protection</h4>
    <div v-if="type === 'phone'" class="form-group">
      <MazPhoneNumberInput
        class="maz-custom"
        ref="phone-contact"
        :translations="translations"
        :default-phone-number="contact"
        default-country-code="FR"
        :value="contact"
        @update="$emit('update:phoneResults', $event)"
        @input="$emit('update:contact', $event)"
      />
      <Alert v-if="errorLogin" :title="errorLoginMsg" type="danger" />
    </div>
    <div v-else class="form-group">
      <input
        type="text"
        id="login"
        data-ob1-component="FormControlEmpty"
        :class="`form-control${!contact || contact.length === 0 ? ' form-control-empty' : ''}${errorLogin ? ' is-invalid' : ''}`"
        aria-labelledby="label-contact"
        ref="mail-contact"
        :value="contact"
        @input="$emit('update:contact', $event.target.value)"
        @keyup.enter="$emit('submit')"
        required
      />
      <label id="label-contact" class="form-control-placeholder" for="login">Adresse e-mail ou n° de mobile</label>
      <Alert v-if="errorLogin" :title="errorLoginMsg" type="danger" />
      <div v-if="warningLogin" class="alert-container alert-warning" role="alert">
        <p class="alert">
          <span class="alert-icon mr-0" aria-hidden="true"></span>
          <span class="ob1-alert-title">
            Veuillez vous connecter sur <a href="https://espaceclientpro.orange.fr">votre Espace client Pro Orange</a> pour mettre à jour vos identifiants de connexion.
          </span>
        </p>
      </div>
    </div>
    <Link :action="() => $router.push('/forgot-identifiers')" text="Réinitialiser un de mes identifiants de connexion" />
    <Link :action="() => $router.push('/find-identifiers')" text="Comment retrouver mes identifiants ?" />
    <button class="btn btn-info m-0 mt-1" type="button" @click="$emit('submit')" :disabled="isLoading">Continuer</button>
  </div>
</template>

<script>
import { MazPhoneNumberInput } from 'maz-ui'
import 'maz-ui/lib/css/base.css'
import 'maz-ui/lib/css/maz-phone-number-input.css'
import Alert from '@/components/Alert/Alert'
import Link from '@/components/Link/Link'

export default {
  name: 'StepIdentifier',
  components: { MazPhoneNumberInput, Alert, Link },
  props: {
    contact: { type: String, required: true },
    type: { type: String, required: true },
    isLoading: { type: Boolean, default: false },
    errorLogin: { type: Boolean, default: false },
    errorLoginMsg: { type: String, default: '' },
    warningLogin: { type: Boolean, default: false },
    translations: { type: Object, required: true },
  },
  emits: ['update:contact', 'update:phoneResults', 'submit'],
}
</script>
